export interface IInvoiceTotal {
  fee: number
  totalAmount: number
  totalAmountWithFee: number
  invoiceAmount: number
  lateFee: number
  customerFee?: number
  pricingPackage: any
  paymentType?: PaymentTypeOptions
}

export enum PaymentTypeOptions {
  Full = 'full',
  Partial = 'partial',
}
